import { render, staticRenderFns } from "./registration-details.vue?vue&type=template&id=64feb576&scoped=true&"
import script from "./registration-details.vue?vue&type=script&lang=js&"
export * from "./registration-details.vue?vue&type=script&lang=js&"
import style0 from "./registration-details.vue?vue&type=style&index=0&id=64feb576&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64feb576",
  null
  
)

component.options.__file = "registration-details.vue"
export default component.exports